module.exports = __webpack_public_path__ + "6b5bf36b28bbaf8dddf0ba457c04e9f9.svg";